export const DELIVERY_METHODS = {
  0: 'IN_STORE_LOCATION',
  1: 'NO_LOCATION',
  2: 'ADDRESS',
};

export const DELIVERY_METHOD_VALUES = {
  IN_STORE_LOCATION: '0',
  NO_LOCATION: '1',
  ADDRESS: '2',
};
